/**
 * Hook for managing referral data
 */
import { useMemo } from "react";
import { useSignup as useSignupContext } from "../../SignupContext";
/**
 * Hook for managing referral data
 *
 * This hook simply provides access to the referral data stored in the SignupContext
 * and doesn't perform any validation, trusting the consuming app to provide valid data.
 *
 * @returns ReferralFields object
 */
export function useReferralData() {
    const { formValues, setFormValues } = useSignupContext();
    return useMemo(() => ({
        referralData: formValues.referralData,
        setReferralData: setFormValues.setReferralData,
    }), [formValues.referralData, setFormValues.setReferralData]);
}
